import React, { useRef, useState, useEffect, Fragment } from 'react'
import SignatureCanvas from 'react-signature-canvas'
import { SpiderWeb } from '../spider-web'
import debounce from 'lodash/debounce'
import './styles.scss'

const getPathDataFromLocalStorage = () => {
  if (window.localStorage) {
    const pathsData = localStorage.getItem('paths-data')
    if (pathsData) return JSON.parse(pathsData)
  }
}

const setPathDataToLocalStorage = pathsData => {
  if (window.localStorage)
    localStorage.setItem('paths-data', JSON.stringify(pathsData))
}

const clearPathsDataInLocalStorage = () => {
  if (window.localStorage) localStorage.removeItem('paths-data')
}

const userDidConfirm = false
const userChoseEtchASketch = false

const DrawArea = () => {
  const canvasRef = useRef()
  const [pathsData, setPathsData] = useState(getPathDataFromLocalStorage())

  useEffect(() => {
    const onShake = () => {
      if (
        !userChoseEtchASketch &&
        !userDidConfirm &&
        !confirm(
          'You woke THE BEAST! THE BEAST has granted you the power of "Etch A Sketch". If you shake, you can kill the art. Wanna use it?'
        )
      ) {
        userDidConfirm = true
        userChoseEtchASketch = false
      } else if (userChoseEtchASketch) {
        clearPathsDataInLocalStorage()
        setPathsData(null)
        canvasRef.current.clear()
        userDidConfirm = true
        userChoseEtchASketch = true
      }
    }

    const onWindowResize = debounce(() => {
      canvasRef.current.fromData(pathsData)
    }, 200)

    if (canvasRef && canvasRef.current) {
      if (pathsData) canvasRef.current.fromData(pathsData)
      window.addEventListener('resize', onWindowResize)
    }
    return () => {
      window.removeEventListener('resize', onWindowResize)
    }
  })

  return (
    <Fragment>
      <SpiderWeb
        onClick={() => {
          clearPathsDataInLocalStorage()
          setPathsData(undefined)
          canvasRef.current.clear()
        }}
      />
      <div className="draw-area">
        <SignatureCanvas
          penColor="black"
          ref={ref => {
            canvasRef.current = ref
          }}
          velocityFilterWeight={0}
          onBegin={() => {}}
          minWidth={1}
          maxWidth={3}
          onEnd={() => {
            const _pathsData = canvasRef.current.toData()
            setPathsData(_pathsData)
            setPathDataToLocalStorage(_pathsData)
          }}
          dotSize={15}
          canvasProps={{
            className: 'draw-canvas'
          }}
        />
      </div>
    </Fragment>
  )
}

export default DrawArea
